module.exports = __webpack_public_path__ + "static/img/item3-bottom.2007904c.png";